/**
 * BillingTab — Tab 5 of the patient-edit shell (PROD-733, PR A).
 *
 * Flutter ref: `create_patient_screen.dart:1199` (`case 4:`) →
 * `PatientBillingBaseScreen`. The permission gate (`Access_Patient_Billing`)
 * is enforced at the tab strip in `patient-edit-page.tsx`; this body
 * trusts the parent.
 *
 * PR A: read-only (Available balance, Invoices, Advance Receipts).
 * Filters → PR B. Mutations → PR C.
 */

import { PatientBillingTabBody } from '@/patients/components/billing/patient-billing-tab-body';
import type { Patient } from '@/types/patient-api';

export interface BillingTabProps {
  patient: Patient | null;
}

export function BillingTab({ patient }: BillingTabProps) {
  return <PatientBillingTabBody patientId={patient?.patientId ?? null} />;
}
